export const filterByRepository = (data?: any, repositoryType?: string) => {
        // Validate input
        if (repositoryType && !['CAMS', 'KARVY', 'ALL']?.includes(repositoryType)) {
          console.log(`Invalid repository type: ${repositoryType}. Please use 'CAMS', 'KARVY' or 'ALL'`);
          return {};
        }
        
        // If ALL, return the original data
        if (repositoryType === 'ALL') {
          return data;
        }
        
        // Filter data by repository type
        const filteredData = {};
        
        Object.entries(data).forEach(([key, asset]) => {
            //@ts-expect-error
          if (asset?.assetRepository === repositoryType) {
            //@ts-expect-error
            filteredData[key] = asset;
          }
        });
        
        return filteredData;
    }